var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrafArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "239px",
    height: "226px",
    viewBox: "0 0 239 226",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graf-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEFD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Statso",
    transform: "translate(-378.000000, -8736.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graf-arrow",
    transform: "translate(378.278215, 8736.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bcg",
    fill: "url(#linearGradient-1)",
    points: "238.001225 108.035436 119.375116 225.285767 1.56319402e-13 108.035436 119.721785 1.56319402e-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ic-arrow",
    fill: "#F7465F",
    fillRule: "nonzero",
    points: "116.691482 94.2857669 122.752088 94.2857669 122.752088 130.649403 139.418755 113.982737 143.721785 118.285767 119.721785 142.285767 95.7217852 118.285767 100.024815 113.982737 116.691482 130.649403"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrafArrow);
export default __webpack_public_path__ + "static/media/graf-arrow.e6ccaa07153986040a2874360fe9a342.svg";
export { ForwardRef as ReactComponent };